/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { Select, SelectProps } from '@mantine/core'
import { parseBoolean } from '@jalik/form-parser'
import FormField from '../../../../client/js/components/form/fields/FormField'

export type FurnishedFieldProps = Omit<SelectProps, 'data'> & {
  nullable?: boolean;
}

function FurnishedField (props: FurnishedFieldProps) {
  const {
    name = 'furnished',
    nullable,
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'furnishing',
        defaultMessage: 'Ameublement'
      })}
      {...others}
      name={name}
      parser={parseBoolean}
      render={Select}
      data={[
        {
          label: intl.formatMessage({
            id: 'undefined',
            defaultMessage: 'Non défini'
          }),
          value: ''
        },
        {
          label: intl.formatMessage({
            id: 'furnished',
            defaultMessage: 'Meublé'
          }),
          value: 'true'
        },
        {
          label: intl.formatMessage({
            id: 'not_furnished',
            defaultMessage: 'Non meublé'
          }),
          value: 'false'
        }
      ].filter((el) => nullable || el.value !== '')}
    />
  )
}

export default FurnishedField
